var _rect, _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessaging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.765813,
    y: 0.750188,
    width: 42.4996,
    height: 42.4996,
    rx: 21.2498,
    stroke: "#E2E8F0",
    strokeWidth: 1.50038
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0186 13.0025H21.0186C16.048 13.0025 12.0186 17.0319 12.0186 22.0025V27.0025C12.0186 29.2116 13.8094 31.0025 16.0186 31.0025H23.0186C27.9891 31.0025 32.0186 26.9731 32.0186 22.0025C32.0186 17.0319 27.9891 13.0025 23.0186 13.0025Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0186,
    cy: 22.0025,
    r: 1,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.0186,
    cy: 22.0025,
    r: 1,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0186,
    cy: 22.0025,
    r: 1,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessaging);
export default __webpack_public_path__ + "static/media/messaging.5298be518fe2bf5b7beb6977cbd74529.svg";
export { ForwardRef as ReactComponent };